/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc チャット画面アプリケーション
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<div id="FastchatApp">
  <fc-chat-starter ref="chatStarter" v-show="visibledChatStarter" @chatStart="chatStartHandler" @chatResume="chatResumeHandler" />
  <fc-chat-window ref="chatWindow" v-show="visibledChatWindow" @chatWindowClose="chatWindowCloseHandler" @chatWindowMinimize="chatWindowMinimizeHandler" @addNewFhMessage="addNewFhMessageHandler" @chatEnd="chatEndHandler" />
</div>
</template>

<script>
import WindowUtil from '@/utils/WindowUtil'
import FcChatStarter from '@/components/chatStarter/FcChatStarter'
import FcChatWindow from '@/components/chatWindow/FcChatWindow'
import DialogUtil from '@/utils/DialogUtil'
import FastchatStateManager from '@/utils/FastchatStateManager'
import ServiceUtil from '@/utils/ServiceUtil'
import ChatMessageConst from '@/constants/ChatMessageConst'

export default {
  name: 'FastchatApp',
  components: {
    FcChatStarter,
    FcChatWindow
  },
  data() {
    return {
      /**
       * 「チャット開始」を表示するか
       * @type {Boolean}
       * @default true
       */
      visibledChatStarter: false,
      /**
       * チャット画面を表示するか
       * @type {Boolean}
       * @default false
       */
      visibledChatWindow: false
    }
  },
  mounted() {
    DialogUtil.App = this
    const mountedFunc = _ => {
      if (WindowUtil.isSeparateWindow()) {
        window.document.title = this.$t('チャットで質問する')
        WindowUtil.updateScreenMode('mobile')
        this.showChatWindow()
        this.$refs['chatWindow'].showFcChatEmptyPane()
        this.chatStartHandler()
      } else if (FastchatStateManager.isStarted() || FastchatStateManager.isSuspended() || FastchatStateManager.isSuspendedWithNewNoticed() || FastchatStateManager.isFastChatConfirmDialogOpened()) {
        if (WindowUtil.isMobileScreenMode() || this.$config['_alwaysSeparateChatWindow'] || FastchatStateManager.isAlwaysSeparateChatWindow()) {
          this.showChatStarter()
        } else {
          if (FastchatStateManager.isChatWindowMinimize() && FastchatStateManager.isSuspended()) {
            this.showChatStarter()
          } else {
            this.botStartByConfirmHandler()
          }
        }
      } else {
        this.showChatStarter()
      }
    }
    if (WindowUtil.isSeparateWindow()) {
      FastchatStateManager.setAlwaysSeparateChatWindow()
      mountedFunc()
    } else {
      WindowUtil.addMessageEventListener('alreadyFastchatFrame', mountedFunc, true)
    }
  },
  methods: {
    /**
     * チャット開始を表示する
     */
    showChatStarter() {
      this.visibledChatStarter = true
      this.visibledChatWindow = false
      WindowUtil.postShowChatStarterMessageToParent()
    },
    /**
     * チャット画面を表示する
     */
    showChatWindow() {
      WindowUtil.postShowChatWindowMessageToParent()
      setTimeout(_ => {
        this.visibledChatStarter = false
        this.visibledChatWindow = true
      }, 0)
    },
    /**
     * BOT開始確認イベントハンドラ
     */
    botStartByConfirmHandler() {
      FastchatStateManager.setChatWindowMinimize('false')
      this.showChatWindow()
      this.$refs['chatWindow'].showFcChatEmptyPane()
    },
    /**
     * チャット画面クローズイベントハンドラ
     */
    chatWindowCloseHandler() {
      if (WindowUtil.isSeparateWindow()) {
        window.close()
      } else {
        this.showChatStarter()
        this.$refs['chatStarter'].changeButtonToChatStart()
      }
    },
    /**
     * チャット画面最小化イベントハンドラ
     */
    chatWindowMinimizeHandler() {
      this.showChatStarter()
      this.$refs['chatStarter'].changeButtonToChatResume()
      this.$refs['chatWindow'].lastScrollMessageList()
      FastchatStateManager.setChatWindowMinimize('true')
    },
    /**
     * チャット再開イベントハンドラ
     */
    chatResumeHandler() {
      FastchatStateManager.setChatWindowMinimize('false')
      this.showChatWindow()
      this.$refs['chatWindow'].showFcChatEmptyPane()
      this.$refs['chatWindow'].scrollMessageListBySnsMessageId(FastchatStateManager.getLastNewFhMessageSnsMessageId())
    },
    /**
     * 新着メッセージイベントハンドラ
     */
    addNewFhMessageHandler() {
      if (this.visibledChatStarter && this.$refs['chatStarter'].buttonMode === 'resume') {
        FastchatStateManager.changeSuspendedWithNewNoticed()
        WindowUtil.postNoticeLabelMessageToParent(this.$t('新着メッセージあり'))
      }
    },
    /**
     * チャット開始イベントハンドラ
     * @return {[type]} [description]
     */
    chatStartHandler() {
      ServiceUtil.request('findFastchatServiceStatus', null, {
        start: _ => {
          this.$refs['chatStarter'].requestingFindFastchatServiceStatus = true
        },
        success: (responseData) => {
          if (!FastchatStateManager.isChatting() && responseData.status === ChatMessageConst.FASTCHAT_SERVICE_STATUS_QUIET_HOURS) {
            this.showChatWindow()
            this.$refs['chatWindow'].showFcChatEmptyPane()
            setTimeout(_ => {
              DialogUtil.showInfoDialog(responseData.message, _ => {
                this.chatWindowCloseHandler()
              })
            }, 0)
            return
          }
          this.botStartByConfirmHandler()
        },
        end: _ => {
          this.$refs['chatStarter'].requestingFindFastchatServiceStatus = false
        }
      })
    },
    /**
     * チャット終了イベントハンドラ
     */
    chatEndHandler() {
      this.showChatWindow()
    }
  }
}
</script>

<style>
html,
#FastchatApp {
  height: 100%;
  overflow: hidden;
  font-family: 游ゴシック体, 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3', Meiryo, メイリオ, Osaka, 'MS PGothic', arial, helvetica, sans-serif;
  border-radius: 5px;
}

body {
  height: 100%;
  margin: 0;
  padding: 0 !important;
}

main {
  display: block;
}

div.el-message-box {
  width: 300px;
}

div.el-message-box p {
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/App.vue